import DevslabComponent from './core/DevslabComponent'
import DevslabBlock from './core/DevslabBlock'

import 'lazysizes'

import { buttonGrid } from '@helper/buttonGrid'
import { lazyLoading } from '@core/lazyloading'
import { handleImageSizes } from '@core/images'
import { mainHeader } from '@helper/mainHeader'
import readmore from '@core/readmore'
import { floatingFormLabels } from '@helper/floatingFormLabels'

window.customElements.define('devslab-component', DevslabComponent)
window.customElements.define('devslab-block', DevslabBlock)

window.addEventListener('load', () => {
  mainHeader()
  floatingFormLabels()
  buttonGrid()
  lazyLoading()
  readmore()
  handleImageSizes(
    Array.from(document.querySelectorAll('img[data-sizes="auto"]'))
  )
})
